import axios from 'axios';
import { getCookie } from '../common/enum';
import { host } from '../environment';

// To do switch dev env or prod
const instance = axios.create({
  baseURL: host.serverTest,
  timeout: 60 * 5 * 1000,
});

const AUTH_TOKEN = localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN');

instance.defaults.headers.common['Authorization'] = `Bearer ${AUTH_TOKEN}`;

instance.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  return Promise.reject(error);
});

instance.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status === 401) {
    localStorage.removeItem('ACCESS_TOKEN');
    localStorage.removeItem('REFRESH_TOKEN');
    localStorage.removeItem('MEMBER');
    localStorage.removeItem('MENUS');
    document.cookie = `ACCESS_TOKEN=`
    document.cookie = `REFRESH_TOKEN=`
    window.location.href = '/login';
  }
  return Promise.reject(error);
});

export default instance;